// Ohio BWC Fee Schedule Types
// Note: CPT descriptions are NOT stored due to AMA licensing requirements

export interface BWCFeeScheduleVersion {
  id: string;
  version: string;
  effective_date: string;
  source_document?: string;
  notes?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface BWCFeeScheduleEntry {
  id: string;
  version_id: string;
  cpt_code: string;
  modifier?: string | null;
  modifier_2?: string | null;
  coverage_flag?: string | null;
  non_facility_fee?: number | null;
  facility_fee?: number | null;
  created_at: string;
}

// Coverage flag meanings (BWC-specific)
export const COVERAGE_FLAGS: Record<string, string> = {
  'BR': 'By Report - Requires documentation',
  'NRC': 'Not Related to Workers Compensation - May require additional documentation',
  'NC': 'Not Covered',
  'PA': 'Prior Authorization Required',
};

// Fee lookup response from official BWC tool
export interface BWCOfficialFeeResponse {
  cpt_code: string;
  modifier?: string;
  description?: string; // Only if retrieved from official source
  non_facility_fee?: number;
  facility_fee?: number;
  effective_date?: string;
  source: 'official_lookup' | 'internal_schedule';
}

// Validation result comparing internal vs official
export interface BWCFeeValidationResult {
  cpt_code: string;
  modifier?: string;
  internal_non_facility_fee?: number;
  internal_facility_fee?: number;
  official_non_facility_fee?: number;
  official_facility_fee?: number;
  non_facility_variance?: number;
  facility_variance?: number;
  match_status: 'match' | 'mismatch' | 'not_in_internal' | 'not_in_official' | 'pending';
  validated_at?: string;
}

// Query filters for fee schedule lookup
export interface BWCFeeScheduleFilters {
  version?: string;
  cpt_codes?: string[];
  modifier?: string;
  coverage_flag?: string;
  min_fee?: number;
  max_fee?: number;
}
